import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M11.729 5.554l-1.262-1.272 1.157-1.158 1.26 1.27-1.155 1.16zm-7.473 7.44H2.998v-1.273l6.057-6.022 1.26 1.269-6.06 6.027zm10.743-8.628c-.006-.461-.19-.888-.498-1.181l-1.644-1.658c-.308-.328-.746-.521-1.202-.527-.47.012-.916.179-1.239.503l-9.122 9.093c-.188.187-.294.442-.294.709v2.69c0 .553.448 1 1 1h2.668c.266 0 .518-.104.707-.291l9.127-9.1c.322-.324.503-.777.497-1.238z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M17.593 9.042l-2.581-2.603 2.469-2.42 2.497 2.519c.006.006-.005.102.002.108l-2.387 2.396zM6.59 20H4v-2.621l9.585-9.538 2.595 2.617L6.59 20zM22 6.557c-.007-.556-.228-1.07-.602-1.427l-2.48-2.5c-.368-.394-.894-.623-1.444-.63h-.027c-.551 0-1.085.222-1.468.607L2.295 16.254c-.188.187-.295.443-.295.709V21c0 .553.447 1 1 1h4.003c.265 0 .518-.104.705-.291l13.69-13.652c.39-.394.61-.941.602-1.5z"
        />
      </g>
    </svg>
  ),
};
